import * as React from 'react';
import * as styles from './reliable.css';
import { PropsWithChildren } from 'react';
import { UIText3, IconTrust16 } from '@cian/ui-kit';

interface IReliableLabel {
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export const ReliableLabel = ({ children, onClick }: PropsWithChildren<IReliableLabel>) => {
  return (
    <div className={styles['label']} onClick={onClick}>
      <span className={styles['icon']}>
        <IconTrust16 color="primary_100" />
      </span>
      <UIText3 color="primary_100">{children}</UIText3>
    </div>
  );
};
